import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Navigate, useLocation} from 'react-router-dom';

import {selectAuth} from '../../Redux/selectors/authSelector';

const ProtectedRoute = ({children, allowedRoles}) => {
  const auth = useSelector(selectAuth);
  const location = useLocation();

  const loggedIn = auth?.loggedIn;
  const user = auth?.user;

  // Not logged in
  if (!loggedIn) {
    return (
      <Navigate
        to={'/'}
        replace
        state={{from: location}}
      />
    );
  }

  // Role not allowed
  if (
    allowedRoles &&
    !allowedRoles.includes(user?.role)
  ) {
    return <Navigate to={'/'} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.array,
};

export default ProtectedRoute;
